import { KlineInterval } from '@/types/chart';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { TvWidget } from './constants';
import { DataFeed } from './datafeed';

interface TradingViewState {
  tradingViewWidget: TvWidget | null;
  setTradingViewWidget: (tradingView: TvWidget | null) => void;
  spotKlineInterval: KlineInterval;
  setSpotKlineInterval: (interval: KlineInterval) => void;
  datafeed: DataFeed | null;
  setDatafeed: (datafeed: DataFeed | null) => void;
}

export const useTradingViewStore = create<TradingViewState>()(
  devtools(
    (set) => ({
      tradingViewWidget: null,
      setTradingViewWidget: (tradingViewWidget) =>
        set(() => ({
          tradingViewWidget,
        })),
      spotKlineInterval: KlineInterval.MINUTE,
      setSpotKlineInterval: (interval) =>
        set(() => ({
          spotKlineInterval: interval,
        })),
      datafeed: null,
      setDatafeed: (datafeed) =>
        set(() => ({
          datafeed,
        })),
    }),
    {
      name: 'trading-view-store',
    },
  ),
);
